<template>
    <div>
        <v-dialog
        v-model="mostrar"
        max-width="290"
        fullscreen
        persistent
        >
            <v-card :loading="loading">
                <v-toolbar color="blue-grey darken-2" dark>
                    <v-toolbar-title>Generar oficio</v-toolbar-title>
                </v-toolbar>

            <v-container text-center>
            <v-row wrap>
                <v-col md="12" style="font-weight: bold;">Número de oficio:</v-col>
                <v-col md="2">
                    <v-select 
                        v-model="numero.secretariaSel"
                        :items="['SG','CGU']"
                        :outlined="outlined"
                    />
                </v-col>
                <v-col md="2">
                    <v-select 
                        v-model="numero.dependenciaSel"
                        :items="numero.dependencias"
                        label="Dependencia:"
                        :outlined="outlined"
                        return-object
                        item-text="nota"
                    />
                </v-col>
                <v-col md="1">
                    <v-select 
                        v-model="numero.mesSel"
                        :items="numero.meses"
                        label="Mes:"
                        :outlined="outlined"
                    />
                </v-col>
                <v-col md="2">
                    <v-select 
                        v-model="numero.tipoSel"
                        :items="numero.tipos"
                        label="Tipo:"
                        :outlined="outlined"
                    />
                </v-col>
                <v-col md="2">
                    <v-text-field
                        label="Número:"
                        v-model="numero.numero"
                        :disabled="numero.tipoSel === 1"
                        :outlined="outlined"
                        :error-messages="numeroErrors"
                        @input="$v.numero.numero.$touch()"
                        @blur="$v.numero.numero.$touch()"
                ></v-text-field>
                </v-col>

                <v-col md="2">
                    <v-select 
                        v-model="numero.anio"
                        :items="numero.anios"
                        label="Año:"
                        :outlined="outlined"
                    />
                </v-col>
                <v-col md="4" v-if="numero.secretariaSel == 'CGU'">
                    <v-autocomplete 
                        auto-select-first
                        v-model="numero.comisionSel"
                        :items="numero.comisiones"
                        label="Comisión:"
                        :outlined="outlined"
                        item-value="_id"
                        item-text="nombre"
                        :filter="customFilter"
                    />
                </v-col>

            </v-row>
            <v-row wrap>

                <v-col md="12" style="font-weight: bold;">Dependencia que emite:</v-col>

                <v-col md="4">
                    <v-text-field
                        label="Dependencia:"
                        v-model="numero.dependenciaSel.dependencia"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>
                <v-col md="4">
                    <v-text-field
                        label="Titular:"
                        v-model="numero.dependenciaSel.titular"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>
                <v-col md="4">
                    <v-text-field
                        label="Puesto:"
                        v-model="numero.dependenciaSel.puesto"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>

            </v-row>
            <v-row wrap>

                <v-col md="12" style="font-weight: bold;">Área que genera:</v-col>


                <v-col md="4">
                    <v-autocomplete 
                        auto-select-first 
                        v-model="dependenciaSel"
                        :items="dependencias"
                        return-object
                        item-text="nombre"
                        label="Dependencia:"
                        :outlined="outlined"
                        @change="cambioDependencia()"
                        :filter="customFilter"
                    />
                </v-col>
                <v-col md="4">
                    <v-select
                        label="Emisor:"
                        v-model="emisorSel"
                        :items="emisores"
                        :outlined="outlined"
                        return-object
                        item-text="nombre"
                        @change="cambioEmisor()"
                ></v-select>
                    
                </v-col>
                <v-col md="4">
                    <v-text-field
                        label="Cargo:"
                        v-model="emisorCargo"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>


                <v-col md="12" style="font-weight: bold;">Datos del destinatario:</v-col>
                <buscarEmisorEntidadComponent
                  :tipo="'Generado'" 
                  :entidades="entidades"
                  @seleccionarEntidad="seleccionarEntidad"
                />

                <v-col md="4">
                    <v-autocomplete 
                        auto-select-first 
                        v-model="entidadSel"
                        :items="entidades"
                        return-object
                        item-text="nombre"
                        label="Entidad:"
                        :outlined="outlined"
                        @change="cambioEntidad()"
                        :filter="customFilter"
                    >
                    <template v-slot:item="{ item }">
                    <ul style="list-style: none;padding-left: 0;">
                        <li >{{ item.nombre }}</li>
                        <li style="font-size: x-small;color: gray;" >{{ item.cargo }} -{{ item.responsable }}</li>
                    </ul>
                </template></v-autocomplete>
                </v-col>
                <v-col md="4">
                    <v-text-field
                        label="Destinatario:"
                        v-model="destinatarioResponsable"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>
                <v-col md="4">
                    <v-text-field
                        label="Cargo:"
                        v-model="destinatarioCargo"
                        :outlined="outlined"
                        readonly
                ></v-text-field>
                </v-col>


                <v-col md="12" style="font-weight: bold;">Datos del oficio:</v-col>

                <v-col md="6">
                    <v-text-field
                        label="Asunto:"
                        v-model="asunto"
                        :outlined="outlined"
                        :error-messages="asuntoErrors"
                        @input="$v.asunto.$touch()"
                        @blur="$v.asunto.$touch()"
                ></v-text-field>
                </v-col>
                <v-col md="3">
                    <v-menu
                        v-model="fechaPicker"
                        :close-on-content-click="false"
                        max-width="290"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            :value="fechaTexto"
                            :outlined="outlined"
                            label="Fecha:"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fecha"
                            locale="es"
                            @change="fechaPicker = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col md="3">
                    <v-select 
                        v-model="statusSel"
                        :items="statusList"
                        item-value="nombre"
                        item-text="nombre"
                        label="Status:"
                        :outlined="outlined"
                    />
                </v-col>

                <v-col md="3">
                    <v-select
                        v-model="tipoSel"
                        :items="tipos" 
                        :outlined="outlined"
                        label="Tipo:"
                        item-text="nombre"
                        item-value="nombre"
                    />
                </v-col>
                <v-col md="2">
                    <v-text-field
                        label="Documentos:"
                        v-model="documentos"
                        :outlined="outlined"
                        :error-messages="documentosErrors"
                        @input="$v.documentos.$touch()"
                        @blur="$v.documentos.$touch()"
                ></v-text-field>
                </v-col>
                <v-col md="3">
                    <v-menu
                        v-model="fechaRecepcionPicker"
                        :close-on-content-click="false"
                        max-width="290"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            :value="fechaRecepcionTexto"
                            :outlined="outlined"
                            label="Fecha recepción:"
                            readonly
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fechaRecepcion"
                            locale="es"
                            @change="fechaRecepcionPicker = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col md="2">
                    <v-menu
                        ref="menu"
                        v-model="horaRecepcionPicker"
                        :close-on-content-click="false"
                        :return-value.sync="horaRecepcion"
                        max-width="1px"
                        min-width="1px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :disabled="false"
                                v-model="horaRecepcion"
                                label="Hora recepción"                   
                                type="time"
                                v-on="on"
                                @change="$refs.menu.save(horaRecepcion)"
                            ></v-text-field>
                        </template>
                    </v-menu>
                </v-col>
                <v-col md="2">
                    <v-select
                        v-model="original"
                        :items="[{value:true,text:'Original'},{value:false,text:'Copia'}]"
                        :outlined="outlined"
                ></v-select>
                </v-col>
                <v-col md="5">
                    <v-text-field
                        label="Recibió:"
                        v-model="recibio"
                        :outlined="outlined"
                ></v-text-field>
                </v-col>
                <v-col md="2">
                    <v-select
                        v-model="requiereRespuesta"
                        label="Requiere respuesta:"
                        :items="[{value:true,text:'Si'},{value:false,text:'No'}]"
                        :outlined="outlined"
                ></v-select>
                </v-col>
                <v-col md="2">
                    <v-menu
                        v-model="fechaRespuestaPicker"
                        :close-on-content-click="false"
                        max-width="290"
                        :disabled="!requiereRespuesta"
                        >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            :value="fechaRespuestaTexto"
                            :outlined="outlined"
                            label="Fecha límite:"
                            readonly
                            v-on="on"
                            :disabled="!requiereRespuesta"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fechaRespuesta"
                            locale="es"
                            @change="fechaRespuestaPicker = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col md="6">
                    <v-textarea
                    v-model="observaciones"
                    label="Observaciones"
                    ></v-textarea>
                </v-col>
            </v-row>
            </v-container>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue-grey darken-1" outlined :disabled="loading" text @click="$emit('cancelar')">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" dark :loading="loading" @click="guardarOficio()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <v-dialog v-model="nuevoNumero.mostrar" width="300">
            <v-card>
                <v-card-title>Número generado: {{nuevoNumero.numero}}</v-card-title>
                <v-card-actions>
                    <v-btn color="blue-grey darken-1" dark  @click="$emit('oficioGuardado',historico);">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {Settings, DateTime} from 'luxon';
import axios from "axios";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, decimal } from "vuelidate/lib/validators";

import buscarEmisorEntidadComponent from "../widgets/buscarEmisorEntidad.vue";

Settings.defaultLocale = 'es';

export default {
    name: "nuevoOficioGenerado",
    props:['mostrar','relacionado'],
    mixins: [validationMixin],
    computed: {
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId"
        ]),
        numeroErrors() {
            const errors = [];
            if (!this.$v.numero.numero.$dirty) return errors;
            !this.$v.numero.numero.required && errors.push("Campo requerido.");
            return errors;
        },
        asuntoErrors() {
            const errors = [];
            if (!this.$v.asunto.$dirty) return errors;
            !this.$v.asunto.required && errors.push("Campo requerido.");
            return errors;
        },
        recibioErrors() {
            const errors = [];
            if (!this.$v.recibio.$dirty) return errors;
            !this.$v.recibio.required && errors.push("Campo requerido.");
            return errors;
        },
        fechaTexto(){
            return this.fecha ? DateTime.fromFormat(this.fecha, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        },
        destinatarioResponsableErrors() {
            const errors = [];
            if (!this.$v.destinatarioResponsable.$dirty) return errors;
            !this.$v.destinatarioResponsable.required && errors.push("Campo requerido.");
            return errors;
        },
        destinatarioCargoErrors() {
            const errors = [];
            if (!this.$v.destinatarioCargo.$dirty) return errors;
            !this.$v.destinatarioCargo.required && errors.push("Campo requerido.");
            return errors;
        },
        emisorCargoErrors() {
            const errors = [];
            if (!this.$v.emisorCargo.$dirty) return errors;
            !this.$v.emisorCargo.required && errors.push("Campo requerido.");
            return errors;
        },
        documentosErrors() {
            const errors = [];
            if (!this.$v.documentos.$dirty) return errors;
            !this.$v.documentos.required && errors.push("Campo requerido.");
            !this.$v.documentos.decimal && errors.push("Debe ingresar un número");
            return errors;
        },
        fechaRecepcionTexto(){
            return this.fechaRecepcion ? DateTime.fromFormat(this.fechaRecepcion, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        recepcion(){
            return this.fechaRecepcion+' '+this.horaRecepcion+':00';
        },
        fechaRespuestaTexto(){
            return this.fechaRespuesta ? DateTime.fromFormat(this.fechaRespuesta, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        },

    },
    validations:{
        numero:{ numero: {required} },
        asunto: {required},
        // destinatarioResponsable: {required },
        // destinatarioCargo: {required },
        emisorCargo: {required },
        documentos: {required, decimal },
        // recibio: {required}
    },
    components: {
      buscarEmisorEntidadComponent,
    },
    data: () => ({
        loading: false,
        outlined: false,
        nuevoNumero: {
            mostrar:false,
            generar: true,
            numero: null
        },
        numero:{
            secretariaSel: 'SG',
            dependencias:[],
            dependenciaSel: {},
            meses: [1,2,3,4,5,6,7,8,9,10,11,12],
            mesSel: DateTime.now().month,
            tipos: [
                {value:1,text:'Consecutivo'},
                {value:2,text:'Manual'},
            ],
            tipoSel: 1,
            numero: 'Autogenerado',
            anios: [DateTime.now().year-5,DateTime.now().year-4,DateTime.now().year-3,DateTime.now().year-2,DateTime.now().year-1,DateTime.now().year,DateTime.now().year+1],
            anio: DateTime.now().year,
            // comisiones: [
            //     { numero: 'I', nombre: 'Comisión de Educación'},
            //     { numero: 'II', nombre: 'Comisión de Hacienda'},
            //     { numero: 'III', nombre: 'Comisión de Revalidación de Estudios, Títulos y Grados'},
            //     { numero: 'IV', nombre: 'Comisión de Normatividad'},
            //     { numero: 'V', nombre: 'Comisión de Condonaciones y Becas'},
            //     { numero: 'VI', nombre: 'Comisión de Responsabilidades y Sanciones'},
            //     { numero: 'VII', nombre: 'Comisión Electoral'},
            //     { numero: 'VIII', nombre: 'Comisión de Ingreso y Promoción del Personal Académico'},
            //     { numero: 'I', nombre: 'Comisión de Educación y Hacienda'},
            // ],
            comisiones:[],
            comisionSel: null
        },
        // numero: null,
        numeroCompleto: null,
        asunto: null,
        fecha: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechaPicker: false,
        statusList: [],
        statusSel: null,
        tipos: [],
        tipoSel: null,
        entidades: [],
        entidadSel: {},
        destinatarioResponsable: null,
        destinatarioCargo: null,
        dependencias: [],
        dependenciaSel: null,
        emisores: [],
        emisorSel: null,
        emisorCargo: null,
        documentos: 0,
        original: true,
        fechaRecepcion: null,
        fechaRecepcionPicker: false,
        horaRecepcion: null,
        horaRecepcionPicker: false,
        recibio: null,
        requiereRespuesta: false,
        fechaRespuesta: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechaRespuestaPicker: false,
        observaciones: null,
        historico: [],
    }),
    watch:{
        requiereRespuesta(nueva){
            if( !nueva )
                this.fechaRespuesta = null;
        },
        'numero.tipoSel'(nuevo,anterior){
            if( nuevo == 1 ){
                this.numero.numero = 'Autogenerado';
            }
            else{
                this.numero.numero = null;
            }
        }
    },
    created(){
        this.loading = true;
        axios.get(this.httpURL+'/oficios/datosGenerales',
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.statusList = res.data.statusList;
                    this.statusSel = this.statusList[0].nombre;
                    this.tipos = res.data.tipoDocumento;
                    this.tipoSel = this.tipos[0].nombre;

                    res.data.emisores.forEach(x => {
                        let obj = x
                        if(x.numero == 'I'){
                            if(x.titular == 'Mtro. Guillermo Arturo Gómez Mata') obj.nota = `${x.numero} Mtro. Guillermo Arturo Gómez Mata` 
                            else if(x.titular == "Mtro. Carlos Oscar Trejo Herrera") obj.nota = `${x.numero} Mtro. Carlos Oscar Trejo Herrera`
                            else if (x.titular == "Mtro. César Antonio Barba Delgadillo") obj.nota = `${x.numero} Mtro. César Antonio Barba Delgadillo`
                        }
                        else if(x.numero == 'II'){
                        if(x.titular == 'Mtra. Karla Ávila Ramos') obj.nota = `${x.numero} Mtra. Karla Ávila Ramos` 
                        else if(x.titular == "Mtra. Isela Ramirez Valadez") obj.nota = `${x.numero} Mtra. Isela Ramirez Valadez`
                        }
                        else if(x.numero == 'III'){
                        if(x.titular == 'Mtro. Jesús Alberto Jiménez Herrera') obj.nota = `${x.numero} Mtro. Jesús Alberto Jiménez Herrera` 
                        else if(x.titular == "Dr. Paulo Alberto Carrillo Torres") obj.nota = `${x.numero} Dr. Paulo Alberto Carrillo Torres`
                        }
                        else if(x.numero == 'IV'){
                        if(x.titular == 'Mtra. Marcela Sinaí Villalpando Barrios') obj.nota = `${x.numero} Mtra. Marcela Sinaí Villalpando Barrios` 
                        else if(x.titular == "Mtro. Marco Antonio Romero Güemez") obj.nota = `${x.numero} Mtro. Marco Antonio Romero Güemez`
                        }
                        else if(x.numero == 'V'){
                        if(x.titular == 'Dr. Ricardo Villanueva Lomelí') obj.nota = `${x.numero} Dr. Ricardo Villanueva Lomelí` 
                        else if(x.titular == "Mtra. Karla Alejandrina Planter Pérez") obj.nota = `${x.numero} Mtra. Karla Alejandrina Planter Pérez`
                        }
                        // else obj.nota = x.numero
                        this.numero.dependencias.push(obj)
                    })

                    this.numero.dependencias = this.numero.dependencias.sort((a, b) => a.nota.localeCompare(b.nota))

                    this.numero.dependenciaSel = this.numero.dependencias[1];
                    this.numero.comisiones = res.data.comisiones;
                    this.numero.comisionSel = this.numero.comisiones[0]._id

                    this.entidades = res.data.entidades;
                    this.entidadSel = this.entidades[0];
                    this.destinatarioResponsable = this.entidadSel.responsable;
                    this.destinatarioCargo = this.entidadSel.cargo;
                    
                    this.dependencias = res.data.dependencias;
                    this.dependenciaSel = this.dependencias[0];
                    this.asignacion = this.dependencias[0]._id;
                    
                    this.cambioDependencia();
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
                this.loading = false;
            })
            .catch(error => {
                //console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
    },
    methods:{
        cambioDependencia(){
            //Se cargan los integrantes de la dependencia
            // console.log(this.dependenciaSel);
            if (this.dependenciaSel != null){
            let emisores = [{
                _id: this.dependenciaSel.titular.usuario._id, 
                nombre: this.dependenciaSel.titular.usuario.titulo+' '+this.dependenciaSel.titular.usuario.nombreCompleto,
                puesto: this.dependenciaSel.titular.puesto, 
            }];
            this.dependenciaSel.integrantes.forEach(integrante => {
                emisores.push({
                    _id: integrante.usuario._id,
                    nombre: integrante.usuario.titulo+' '+integrante.usuario.nombreCompleto,
                    puesto: integrante.puesto,
                });
            });
            this.emisores = emisores;
            this.emisorSel = emisores[0];
            this.emisorCargo = emisores[0].puesto;
            }
            // console.log(dependencia);
        },
        cambioEmisor(){
            this.emisorCargo = this.emisorSel.puesto;
        },
        cambioEntidad(){
            if (this.entidadSel != null) {
            this.destinatarioResponsable = this.entidadSel.responsable;
            this.destinatarioCargo = this.entidadSel.cargo;
            }
        },
        guardarOficio(){
            this.$v.$touch(); 
            
                if (!this.$v.$invalid) {
                    //Se preparan los datos para ser enviados
                    let data = {
                        numero:{
                            secretaria: this.numero.secretariaSel,
                            dependencia: this.numero.dependenciaSel.numero,
                            mes: this.numero.mesSel,
                            numero: this.numero.numero,
                            anio: this.numero.anio,
                            comision: this.numero.secretariaSel == 'CGU' ? this.numero.comisionSel : null
                        },
                        numeroCompleto: this.numeroCompleto,
                        asunto: this.asunto,
                        fecha: this.fecha,
                        status: this.statusSel,
                        emisor: { 
                            dependencia: this.dependenciaSel,
                            usuario: this.emisorSel,
                            cargo: this.emisorCargo
                        },
                        destinatario: {
                            entidad: this.entidadSel._id,
                            responsable: this.destinatarioResponsable,
                            cargo: this.destinatarioCargo
                        },
                        tipoDocumento: this.tipoSel,
                        documentos: this.documentos,
                        fechaRecibido: this.fechaRecepcion ? (this.horaRecepcion? (this.fechaRecepcion+' '+this.horaRecepcion):this.fechaRecepcion) : null,
                        original: this.original,
                        recibio: this.recibio,
                        captura: {
                            fecha: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd TT"),
                            usuario: this.userId
                        },
                        fechaRespuesta: this.requiereRespuesta ? this.fechaRespuesta : null,
                        observaciones: this.observaciones
                    };
                    
                    this.loading = true;
                    axios.post(this.httpURL+'/oficios/generado', 
                        {data,tipoNumero:this.numero.tipoSel, relacionado: this.relacionado},
                        {headers:{token:this.sessionToken}})
                        .then(res => {
                            // console.log(res.data);
                            if( res.data.ok ){
                                this.$notify({ group: 'gral_notif', type:"success", duration:1500, speed: 500, text: res.data.mensaje });
                                this.$emit('nuevoLog')
                                if( this.numero.tipoSel == 1 ){
                                    this.nuevoNumero.numero = res.data.numero;
                                    this.nuevoNumero.mostrar = true;
                                    this.historico = res.data.historico;
                                }else
                                    this.$emit('oficioGuardado');
                            }else{
                                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                            }
                            this.loading = false;
                        })
                        .catch(error => {
                            // console.log(error);
                            this.loading = false;
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                        });
            }
        },
        seleccionarEntidad(entidad){
          this.entidadSel = entidad;
          this.destinatarioResponsable = this.entidadSel.responsable;
          this.destinatarioCargo = this.entidadSel.cargo;
        },
        normalizarTexto(texto) {
            if (!texto) return ""; // Manejar valores nulos o vacíos
            return texto
                .normalize("NFD") // Divide caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
                .toLowerCase(); // Convierte a minúsculas
        },
        // Filtro personalizado para manejar búsqueda insensible a acentos
        customFilter(item, queryText, itemText) {
            // Normaliza el texto ingresado y el texto del ítem
            const textoBusquedaNormalizado = this.normalizarTexto(queryText);
            const textoItemNormalizado = this.normalizarTexto(itemText);

            // Realiza la comparación
            return textoItemNormalizado.includes(textoBusquedaNormalizado);
        },
    }
}
</script>